const layer = {
  sizes: ['(min-width: 769px) 60vw', '100vw'],
  srcSetWidths: [700, 900, 1200, 1600],
  ratio: 1.25,
};

const layerZoom = {
  sizes: ['100vw'],
  srcSetWidths: [900, 1200, 1600, 2000],
  ratio: 1.25,
};

const thumbnail = {
  sizes: ['(min-width: 769px) 19vw', '48vw'],
  srcSetWidths: [350, 450, 600, 800],
  ratio: 1,
};

const fabricInfo = {
  sizes: ['(min-width: 769px) 900w', '1600w'],
  srcSetWidths: [900, 1600],
  ratio: 1,
};

const sheetWidth = 820;

export const imageDefinition = {
  layer,
  layerZoom,
  thumbnail,
  fabricInfo,
  sheetWidth,
};

export const imageBaseUrl = 'https://cdn.suitsupply.com/image/upload';

export const fabricThumbnailDefaultPath = 'products/cm-sample/default/';
